<section>
  <h3>{{ 'transparency_report_uppercase' | translate }}</h3>
  <p class="account-transparency-report-paragraph ods-typography-body-s-regular">
    {{ 'you_can_view_the_transparency_report' | translate }}
    <a href="https://w4ve.s3.eu-central-1.amazonaws.com/box/configuration/legal/transparency-reports.csv"
      >{{ 'here_' | translate }}</a
    >.
  </p>
</section>
